import React, { Component } from "react";
import ReactGA from "react-ga";

export default function withTracker(WrappedComponent, options = {}) {
  const GATracker = class extends Component {
    componentDidMount() {
      const page = window.location.pathname;
      ReactGA.pageview(page);
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return GATracker;
}



// WEBPACK FOOTER //
// ./src/components/WithTracker/WithTracker.js